import { numberField, stringField, optionField } from '@/common/utils/form/fieldTypes';

export const crew_member_username = 'crew_member_username';
export const crew_member_password = 'crew_member_password';
export const deactivate_vessel_access_days_after_sign_off =
  'deactivate_vessel_access_days_after_sign_off';
export const crew_ticketing_cases_show_pdf_export = 'crew_ticketing_cases_show_pdf_export';
export const crew_member_external_id_keys = 'crew_member_external_id_keys';
export const crew_wage_group_automation_from = 'crew_wage_group_automation_from';
export const crew_wage_group_automation_to = 'crew_wage_group_automation_to';

export type CrewProfileContractsDefaultView =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type CrewTicketingCasesShowPdfExport =
  | {
      label: string;
      value: 0 | 1;
    }
  | 0
  | 1
  | null;

export type CrewWageGroupAutomationFrom =
  | {
      label: string;
      value: 'sign_on_date' | 'contract_from_date';
    }
  | string
  | null;

export type CrewWageGroupAutomationTo =
  | {
      label: string;
      value: 'sign_off_date' | 'contract_to_date' | 'arrived_home_date';
    }
  | string
  | null;

export type CrewAutomatedCredentialsType = {
  [crew_member_username]: string;
  [crew_member_password]: string;
  [deactivate_vessel_access_days_after_sign_off]: string;
  [crew_ticketing_cases_show_pdf_export]: CrewTicketingCasesShowPdfExport;
  [crew_member_external_id_keys]: Array<{ key?: string; label?: string }>;
  [crew_wage_group_automation_from]: CrewWageGroupAutomationFrom;
  [crew_wage_group_automation_to]: CrewWageGroupAutomationTo;
};

const config = {
  [crew_member_username]: stringField(),
  [crew_member_password]: stringField(),
  [deactivate_vessel_access_days_after_sign_off]: numberField(),
  [crew_ticketing_cases_show_pdf_export]: optionField(),
  [crew_member_external_id_keys]: {
    key: stringField(),
    label: stringField()
  },
  [crew_wage_group_automation_from]: optionField({
    initialValue: { label: 'Sign on', value: 'sign_on_date' }
  }),
  [crew_wage_group_automation_to]: optionField({
    initialValue: { label: 'Sign off', value: 'sign_off_date' }
  })
};

export default config;
